import { Component, Inject } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';

import { AsyncPipe } from '@angular/common';

import {
  Firestore,
  docData,
  doc,
  collection,
  collectionData,
  query,
  where,
  orderBy,
} from '@angular/fire/firestore';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';

import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-company',
  imports: [AsyncPipe, CommonModule],
  templateUrl: './company.component.html',
  styleUrl: './company.component.css',
})
export class CompanyComponent {
  // firestore = inject(Firestore);
  item$: Observable<any> | null = null;
  id$: string | null = null;
  username$: string | null = null;
  jobs$: Observable<any[]> | null = null;
  private destroy$ = new Subject<void>();
  readMore: { [key: number]: boolean } = {}; // Object to track each job's readMore state

  constructor(
    private firestore: Firestore,
    private route: ActivatedRoute,
    private meta: Meta,
    private title: Title,
    private router: Router,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.id$ = this.route.snapshot.paramMap.get('id');

    if (this.id$) {
      this.item$ = docData<any>(
        doc(this.firestore, `/tenants/${this.id$}/access/public`)
      );

      this.jobs$ = collectionData(
        query(
          collection(this.firestore, `/tenants/${this.id$}/jobs`),
          where('status', '==', 'active'),
          orderBy('createdAt', 'desc')
        ),
        { idField: 'id' }
      );

      // Update page meta whenever company data is available
      this.item$.subscribe((data) => {
        if (data) this.updatePageMeta(data);
      });
    }
  }

  updatePageMeta(data: any): void {
    const pageTitle = `${data.name} Careers — Maritime Jobs | VoyageX Jobs`;
    const pageDescription = `Discover career opportunities at ${data.name}. Explore maritime jobs for Deck Officers, Marine Engineers, and Crew. Apply now with VoyageX Jobs!`;

    this.title.setTitle(pageTitle);

    // <meta name="robots" content="noindex, nofollow, noarchive">
    this.meta.updateTag({ name: 'robots', content: 'index, follow, archive' });

    this.meta.updateTag({ name: 'description', content: pageDescription });
    this.meta.updateTag({
      name: 'keywords',
      content: `${data.name} jobs, seafarer jobs, captain jobs, engineer roles, maritime careers, VoyageX Jobs`,
    });
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({
      property: 'og:description',
      content: pageDescription,
    });
    this.meta.updateTag({
      property: 'og:url',
      content: `https://jobs.voyagex.ai/company/${this.id$}`,
    });
    this.meta.updateTag({
      property: 'og:image',
      content: data?.photoUrl || 'assets/icon_1024.png',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({
      name: 'twitter:description',
      content: pageDescription,
    });
    this.meta.updateTag({
      name: 'twitter:image',
      content: data?.photoUrl || 'assets/icon_1024.png',
    });

    // let links = this.doc.getElementsByTagName('link');
    // links[0].setAttribute('href', `https://homofer.com${this.path}/`);

    const canonicalLink: HTMLLinkElement =
      this.document.querySelector("link[rel='canonical']") ||
      this.document.createElement('link');
    canonicalLink.setAttribute('rel', 'canonical');
    canonicalLink.setAttribute(
      'href',
      `https://jobs.voyagex.ai/company/${this.id$}`
    );

    if (!this.document.head.contains(canonicalLink)) {
      this.document.head.appendChild(canonicalLink);
    }
  }

  formatString(value: string) {
    return value?.length > 150 ? value.substring(0, 150) + '...' : value;
  }

  handleReadMore(index: number) {
    this.readMore[index] = !this.readMore[index]; // Toggle for specific job
  }
}
